export default __webpack_public_path__ + "static/media/undraw_Beach_rvmg.6927afe2.svg";